export default {
    colors: {
      black: '#000e1a',
      white: '#fff',
      blue: '#007ce0',
      navy: '#004175',
    },
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    sizes:[0,10,20,30,40]
  }